"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.suggestions.title': 'AI Prompt Enhancement',
    'ai.suggestions.description': 'Select one or more suggestions to insert into your prompt for review. You can then edit and submit manually.',
    'ai.suggestions.apply': 'Apply Suggestions',
    'ai.suggestions.clarification': 'Additional clarification',
    'ai.suggestions.clarification.label': 'Additional clarification (optional)',
    'ai.suggestions.clarification.placeholder': 'Add any specific requirements or context...',
    'ai.suggestions.context.prompt': 'From input',
    'ai.suggestions.context.message': 'Last message',
};
